<div class="overview-product_add">
  @if (productService.isTypeStock(product)) {
    <div
    class="product-buy-option-bar product-buy-option-bar_buy-all {{
      !isBuyAllEnabled() ? ' product-buy-option-bar--disabled' : ''
    }}"
      >
      <div class="product-buy-option-bar_price">
        {{ userCurrency }}&nbsp;{{ buyAllPrice | number: "1.2-2" }}
      </div>
      <div
        class="product-buy-option-bar_input product-buy-option-bar_input_no-controls"
        >
        <div class="quantity-input_container">
          @if (isBuyAllEnabled()) {
            <span class="quantity-input_placeholder">{{
              getAvailableQuantity() / product.qtyByBox
            }}</span>
          }
        </div>
      </div>
      <div class="product-buy-option-bar_button">
        <button
          (click)="buyAll()"
          [attr.disabled]="disableBuyAllButton() ? 'disabled' : null"
        class="button button--small button--icon-right button--text-left button--green theme-btn-success {{
          !isBuyAllEnabled() ? 'button--disabled' : ''
        }}"
          >
          @if (!showConfirmation) {
            @if (!buttonShowPressed) {
              @if (isBuyAllEnabled()) {
                <render-checkout-icon
                  [fastCheckout]="isFastCheckout()"
                  [iconHeight]="16"
                  [iconWidth]="31"
                ></render-checkout-icon>
              }
            }
            @if (buttonShowPressed) {
              <svg class="icon-spinner" height="14" width="14">
                <use xlink:href="images/icons/svg-sprite.svg#spinner"></use>
              </svg>
            }
            <strong i18n="@@buy.options.buy.all">Buy all</strong>
            {{ getAvailableQuantity() / product.qtyByBox }} x
            {{ product.qtyByBox }}
          }
          @if (showConfirmation) {
            <svg class="icon-check" height="14" width="16">
              <use xlink:href="images/icons/svg-sprite.svg#check"></use>
            </svg>
            <strong class="product-buy-option-bar_confirmation">
              <ng-container
              i18n="
                Label shown after products were
                added@@buy.options.products.added"
                >Products added
            </ng-container>
            </strong>
          }
        </button>
      </div>
    </div>
  }

  <!-- Tray -->
  <buy-unit
    [disabled]="disabled"
    [itemDiscountPrice]="product.unitDiscountPrice"
    [itemPrice]="product.unitPrice"
    [itemsInOrder]="itemsInOrder"
    [itemsPerUnit]="product.qtyByBox"
    [product]="product"
    unitDescription="x {{ product.qtyByBox }}"
  ></buy-unit>

  <!-- Layer -->
  <buy-unit
    [disabled]="disabled"
    [itemDiscountPrice]="product.layerDiscountPrice"
    [itemPrice]="product.layerPrice"
    [itemsInOrder]="itemsInOrder"
    [itemsPerUnit]="product.qtyByBox * product.qtyPackingsByLayer"
    [product]="product"
    unitDescription="x {{ product.qtyPackingsByLayer }} x {{
      product.qtyByBox
    }}"
  ></buy-unit>

  <!-- Trolley -->
  <buy-unit
    [disabled]="disabled"
    [itemDiscountPrice]="product.trolleyDiscountPrice"
    [itemPrice]="product.trolleyPrice"
    [itemsInOrder]="itemsInOrder"
    [itemsPerUnit]="product.qtyByTrolley"
    [product]="product"
    unitDescription="x {{ product.qtyPackingsByTrolley }} x {{
      product.qtyByBox
    }}"
  ></buy-unit>
</div>
